import React, { Component } from 'react';
import { Group, Rect, Text } from 'react-konva';

export class QrCodeComponentCanvas extends Component {
    render() {
        const { component, isSelected, dimentionsRatio, draggable } = this.props;

        const resizedWidth = component.width * dimentionsRatio;
        const resizedHeight = component.height * dimentionsRatio;
        
        let fontSize = resizedHeight * 0.8;
        if(fontSize > resizedWidth) {
            fontSize = resizedWidth - 10;
        }

        return (
            <Group
                offsetX={component.offsetX}
                offsetY={component.offsetY}
                draggable={draggable}
                onDragEnd={this.props.onDragEnd}
                onClick={this.props.onComponentClick ? () => this.props.onComponentClick(component.internalId) : null} >
                <Rect x={component.drawPositionX}
                    y={component.drawPositionY}
                    width={resizedWidth}
                    height={resizedHeight}
                    strokeWidth={isSelected ? 3 : 1}
                    stroke={isSelected ? "#6699ff" : "black"}
                    fill={component.color} />
                <Text
                    text="&#xe039;"
                    fontSize={fontSize}
                    fontFamily="Glyphicons Halflings"
                    fill="#C3E2F0"
                    stroke="black"
                    strokeWidth="1px"
                    x={component.drawPositionX + (resizedWidth / 2.0) - (fontSize / 2.0)}
                    y={component.drawPositionY + (resizedHeight / 2.0) - (fontSize / 3.4)} />
            </Group>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/componentCanvas/QrCodeComponentCanvas.js